import { render } from "./SimpleHeader.vue?vue&type=template&id=5956ec73&scoped=true"
const script = {}

import "./SimpleHeader.vue?vue&type=style&index=0&id=5956ec73&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5956ec73"]])

export default __exports__